import {handleComponents} from "../global/components";
import {switchToDetail} from "./toolbar/detail";

const myEvent = new CustomEvent("loadGrid", {
	detail: {},
	bubbles: true,
	cancelable: true,
	composed: false,
});

window.myEvent = myEvent;

export function reloadGridDetailContent() {
	let detail = false;
	if (window.location.hash.match(/^#\!detail\-/)) {
		let pk = window.location.hash.replace('#!detail-', '');
		showLoadingProgress()
		loadDetailContent(pk, false);
		detail = true;
	}

	if (! detail) {
		document.querySelector("body").dispatchEvent(myEvent);
	}

	if (typeof gridSettings.api !== 'undefined') {
		let pk = window.location.hash.replace('#!detail-', '');
		let node = gridSettings.api.getRowNode(pk);
		if (node) {
			node.setSelected(true, true);
		}
	}
}

export function loadDetailContent(primaryKey, writeHistory = true, shopCode = 'CZ') {
	var detailUrl = detailLink.replace('9999999', primaryKey)

	if (writeHistory) {
		var newWindowTitle = 'Detail #' + primaryKey + ' | ' + windowTitle
		document.title = newWindowTitle

		window.history.pushState(
			{
				type: 'detail',
				title: document.title
			},
			newWindowTitle,
			window.location.pathname +
			window.location.search +
			'#!detail-' +
			primaryKey
		)
	}

	$.get({url: detailUrl, cache: false}, function (htmlData) {
		$('[data-role="detail"]').html(htmlData)

		let detailTitle = $('[data-role="detail"] detail-title').html()
		if (typeof detailTitle != 'undefined') {
			document.title = detailTitle + ' | K1'
		}

		hideLoadingProgress()

		handleComponents('[data-role="detail"]');

		_.forEach(detailContentLoaderCallback, function(callback) {
			if (typeof callback === 'function') {
				callback()
			}
		})

		$('[data-role="list"]').hide();
		$('[data-role="detail"]').show();
		$('#gridViewSwitcher').kendoButtonGroup().data('kendoButtonGroup').select(1);

		if (! writeHistory) {
			// document.querySelector("body").dispatchEvent(myEvent);
		}
	}).fail(function () {
		hideLoadingProgress()
	})
}

export function showDetail(params) {
  if (typeof customDetail !== 'undefined') {
    customDetail(params);
    return;
  }

	if (params.colDef.editable === false || typeof params.colDef.editable === "undefined") {
		if (params.event.shiftKey) {

			if (window.location.href.match(/#$/)) {
				var url = window.location.href + '!detail-' + params.data.id
			} else {
				var url = window.location.href + '#!detail-' + params.data.id
			}

			window.open(url, '_blank')
		} else {
			switchToDetail();
		}
	}
}
